import { ReactNode } from 'react';

import { Col, Row } from 'approot/shared/grid/grid';

export const NarrowerContainer = ({ children }: { children: ReactNode }) => (
  <Row>
    <Col lg={9}>{children}</Col>
  </Row>
);
